module.exports = __webpack_public_path__ + "img/icon-employees-light-old.359d022c.svg";